import React, { useEffect } from 'react';

import './DiscountProgramPopup.scss';

export default function DiscountProgramPopup(props) {
  useEffect(() => {
    document.body.addEventListener('click', closePopup);

    return () => document.body.removeEventListener('click', closePopup);
  }, []);

  return (
    <section className="discountProgramPopup">
      <div className="discountProgramPopup_content">
        <div className="discountProgramPopup_close_button">
          <span onClick={() => props.showDiscountProgramPopup(false)}>
            Sluiten <span>&times;</span>
          </span>
        </div>

        <p className="discountProgramPopup_title">
          Deze actie is speciaal geselecteerd voor leden van het Familie
          Voordeel Programma. Wil je graag meer weten? Je leest hier alles over
          het lidmaatschap.
        </p>

        <a href="/discount-program-register">Lid worden</a>

        <a href="/hoe-werkt-het-familie-voordeel-programma">Meer informatie</a>
      </div>
    </section>
  );

  function closePopup(e) {
    if (e.target.closest('.discountProgramPopup_content')) return;

    props.showDiscountProgramPopup(false);
  }
}
